module.exports = __webpack_public_path__ + "img/renew.c2a5c329.svg";